/**
 * CircularButton Component
 * Semi-circle button for the HUD with joystick icon
 */

import { useState } from 'react'
import { getDeviceInfo } from '../../utils/deviceDetection'

export function CircularButton({ position = 'left', onClick, label }) {
  const [isHovered, setIsHovered] = useState(false)
  const className = position === 'right' ? 'hud-circular-button-right' : 'hud-circular-button'
  const textClassName = position === 'right' ? 'hud-circular-button-right-text' : 'hud-circular-button-text'
  const color = isHovered ? '#000000' : '#ee3a17'
  const deviceInfo = getDeviceInfo()
  const isMobile = deviceInfo.isMobile

  return (
    <div
      className={className}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {position === 'right' && label && (
        <span className={textClassName}>{label}</span>
      )}
      {!isMobile && (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          style={{
            pointerEvents: 'none',
            flexShrink: 0
          }}
        >
          <circle cx="6" cy="6" r="4" fill={color} />
        </svg>
      )}
      {position === 'left' && label && (
        <span className={textClassName}>{label}</span>
      )}
    </div>
  )
}
